var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 1,
    height: 6,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 9,
    width: 1,
    height: 6,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.38324 0 0 5.38324 0 12C0 18.6168 5.38324 24 12 24C18.6168 24 24 18.6168 24 12C24 5.38324 18.6168 0 12 0ZM12 22.9565C5.95822 22.9565 1.04348 18.0418 1.04348 12C1.04348 5.95822 5.95822 1.04348 12 1.04348C18.0418 1.04348 22.9565 5.95822 22.9565 12C22.9565 18.0418 18.0418 22.9565 12 22.9565Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.eff7df505cc8ba8dfa28c180cdbc87b6.svg";
export { ForwardRef as ReactComponent };